import React from 'react';
import { AuthState } from './types.js';

// Only exported for use in tests/mocks; do NOT reference directly in prod code
export const AuthenticationContext = React.createContext<AuthState>({} as AuthState);
